<template>
  <div class="aiaibot-button-group" ref="container">
    <template v-if="!clicked">
      <ChatButton
        v-for="(button, index) in buttons"
        class="button"
        :key="index"
        :label="button"
        :types="types"
        :disabled="disabled"
        @click="onClick(index)"
      />
    </template>
  </div>
</template>

<script>
import { computed, onMounted, ref } from '@vue/composition-api'
import store from '@/store'
import ChatButton from '@/components/ChatButton'

const FREE_TEXT_BUTTON_CONFIG = {
  values: process.env.VUE_APP_AIAIBOT_AUTO_FREETEXT_BUTTON_VALUES
    .split(',')
    .map(value => value.toLowerCase()),
  delay: process.env.VUE_APP_AIAIBOT_AUTO_FREETEXT_DELAY_IN_MS
}

const IS_AUTO_FREETEXT_ENABLED = process.env.VUE_APP_AIAIBOT_AUTO_FREETEXT_DELAY

export default {
  name: 'AiaiBotButtonGroup',
  components: {
    ChatButton
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    types: {
      type: Array,
      default: () => ['transparent']
    }
  },
  setup(props) {
    const container = ref(null)
    const buttons = ref([])
    const clicked = ref(false)
    const disabled = computed(() =>
      store.state.conversation.conversation.status === 'AIAIBOT_ENDED'
    )
    
    let freeTextIndex

    const getMessagePayload = index => ({
        msgType: 'AIAIBOT_FEEDBACK',
        widgetType: 'button',
        content: props.options[index]
      })

    const onClick = index => {
      store.dispatch('conversation/sendMessage', getMessagePayload(index))
      clicked.value = true
    }

    onMounted(async () => {
      freeTextIndex = props.options.findIndex(
        option => FREE_TEXT_BUTTON_CONFIG.values.includes(option.toLowerCase())
      )

      if (IS_AUTO_FREETEXT_ENABLED && freeTextIndex > -1) {
        buttons.value = props.options.filter(
          (_, index) => index !== freeTextIndex
        )

        setTimeout(() => {
          if (clicked.value) {
            return
          }
          
          store.dispatch(
            'conversation/sendMessage',
            getMessagePayload(freeTextIndex)
          )
          clicked.value = true
        }, FREE_TEXT_BUTTON_CONFIG.delay)
      } else {
        buttons.value = props.options
      }
    })

    return { buttons, clicked, container, disabled, onClick }
  }
}
</script>

<style scoped lang="postcss">
.aiaibot-button-group {
  display: grid;
}

.button {
  &.focused,
  &:hover {
    color: white;
    background-color: var(--tw-c-original-green);
  }

  &:active {
    background-color: var(--tw-c-sanitas-green);
  }
}
</style>
